var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.98 3C4.98 4.381 3.87 5.5 2.5 5.5C1.13 5.5 0.02 4.381 0.02 3C0.02 1.62 1.13 0.5 2.5 0.5C3.87 0.5 4.98 1.62 4.98 3ZM5 7.5H0V23.5H5V7.5ZM12.982 7.5H8.014V23.5H12.983V15.101C12.983 10.431 19.012 10.049 19.012 15.101V23.5H24V13.369C24 5.489 15.078 5.776 12.982 9.655V7.5Z","fill":"#151515"}));
}

LinkedinInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
